export default "__VITE_ASSET__0f9c4edb__"